export default __webpack_public_path__ + "6384849f8bd42bbee605920caa63a90a.svg";